import React, { useState, Fragment } from 'react';
import { makeStyles, Box, Typography } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import { INFO_PAGE_APP_FUNCTIONS, LIST_APPLICATION_FUNCTIONS } from '../utils';
import GenericMedia from './genericMedia';
import Weather from './weather';
import Radio from './radio';
import RSS from './RSS';
import RemoteSiteLauncher from './remoteSiteLauncher';
import ServiceCall from './serviceCall';
import SlideShow from './slideShow';
import LaunchTVApp from './launchTVApp';
import PlayMovie from './playMovie';
import StartInActiveBrowser from './startInActiveBrowser';
import GenericQRCaster from './genericQRCaster';
import MediaGrid from './mediaGrid';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import SelectBoxFilter from '../common/select-box-filter'

import Model_StartInactiveBrowser from '../redux/model/StartInactiveBrowser';
import Model_Weather from '../redux/model/Weather';
import Model_GenericMediaItem from '../redux/model/GenericMediaItem';
import Model_GenericQRCaster from '../redux/model/GenericQRCaster';
import Model_Movie from '../redux/model/Movie';
import Model_ServiceCall from '../redux/model/ServiceCall';
import Model_SlideShow from '../redux/model/SlideShow';
import Model_TVApp from '../redux/model/TVApp';
import Model_MediaGrid from '../redux/model/MediaGrid';
import Model_Radio from '../redux/model/Radio';
import Model_RemoteSiteLauncher from '../redux/model/RemoteSiteLauncher';
import Model_RSS from '../redux/model/RSS';

const useStyles = makeStyles(theme => ({
    borderCard: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '600px',
        // height: '132px',
        marginTop: '18px'
    },
    titleNodeType: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },


}));

const {
    LAUNCH_TV_APP, GENERIC_MEDIA, PLAY_MOVIE, START_INACTIVE_BROWSER, MEDIA_GRID, RADIO, REMOTE_SITE_LAUNCHER,
    RSS: INFO_PAGE_RSS, SERVICE_CALL, SLIDE_SHOW, WEATHER, GENERIC_QR_CASTER, EXTERNAL_SERVICES,//, CHILD_LOCK
} = INFO_PAGE_APP_FUNCTIONS;

function Application() {
    const classes = useStyles();
    const translate = useTranslate();
    const dispatch = useDispatch();

    const [openPoper, setOpenPopper] = useState(false);
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const nodeData = nodeSelected.applicationData;
    const { func } = nodeData.nodeApplication;

    const onChangeFunction = (func) => {
        // Init model if undefined
        if (func.id === INFO_PAGE_APP_FUNCTIONS.START_INACTIVE_BROWSER && nodeData.nodeApplication.startInactiveBrowser === undefined) {
            nodeData.nodeApplication.startInactiveBrowser = new Model_StartInactiveBrowser();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.WEATHER && nodeData.nodeApplication.weatherLocation === undefined) {
            nodeData.nodeApplication.weatherLocation = new Model_Weather();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.GENERIC_MEDIA && nodeData.nodeApplication.genericMediaItem === undefined) {
            nodeData.nodeApplication.genericMediaItem = new Model_GenericMediaItem();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.GENERIC_QR_CASTER && nodeData.nodeApplication.genericQRCaster === undefined) {
            nodeData.nodeApplication.genericQRCaster = new Model_GenericQRCaster();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.PLAY_MOVIE && nodeData.nodeApplication.movie === undefined) {
            nodeData.nodeApplication.movie = new Model_Movie(0, 0);
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.SERVICE_CALL && nodeData.nodeApplication.serviceCall === undefined) {
            nodeData.nodeApplication.serviceCall = new Model_ServiceCall();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.SLIDE_SHOW && nodeData.nodeApplication.slideShow === undefined) {
            nodeData.nodeApplication.slideShow = new Model_SlideShow();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.LAUNCH_TV_APP && nodeData.nodeApplication.tvApp === undefined) {
            nodeData.nodeApplication.tvApp = new Model_TVApp();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.MEDIA_GRID && nodeData.nodeApplication.mediaGrid === undefined) {
            nodeData.nodeApplication.mediaGrid = new Model_MediaGrid();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.RADIO && nodeData.nodeApplication.radio === undefined) {
            nodeData.nodeApplication.radio = new Model_Radio();
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.REMOTE_SITE_LAUNCHER && nodeData.nodeApplication.remoteSiteLauncher === undefined) {
            nodeData.nodeApplication.remoteSiteLauncher = new Model_RemoteSiteLauncher(false);
        } else if (func.id === INFO_PAGE_APP_FUNCTIONS.RSS && nodeData.nodeApplication.Rss === undefined) {
            nodeData.nodeApplication.Rss = new Model_RSS();
        }

        const newNode = {
            ...nodeData,
            nodeApplication: {
                ...nodeData.nodeApplication,
                func
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    return (
        <Box>
            <Box mt={3.5}>
                <Box className={classes.borderCard} display='flex' justifyContent='center'>
                    <Box width="100%" mx={2} my={3}>
                        <Typography style={{ marginTop: '10px' }} className={classes.titleNodeType}>{translate('resources.infoPage.special_attr')}</Typography>
                        <Box display='flex' style={{ marginRight: '47px', position: 'relative' }}>
                            <Box width="500px" mt={2} >
                                <SelectBoxFilter
                                    disabled={!isEditing}
                                    data={LIST_APPLICATION_FUNCTIONS.map(item => ({
                                        ...item,
                                        label: translate(item.label)
                                    }))}
                                    label={translate('resources.infoPage.function')}
                                    value={translate(LIST_APPLICATION_FUNCTIONS.find(item => item.id === func.id).label)}
                                    onChange={(value) => onChangeFunction(value)}
                                    keyName='label'
                                    placeholder={translate('resources.infoPage.filter_function')}
                                />
                            </Box>
                            <Box style={{ position: 'absolute', right: -25, top: 50 }}>
                                <CustomPoper
                                    color={'#c1e5fa'}
                                    fontSize={'11px'}
                                    open={openPoper}
                                    handleClick={() => setOpenPopper(true)}
                                    handleClose={() => setOpenPopper(false)}
                                    title={translate(`pos.common.function`)}
                                    content={translate(`pos.common.contentFunction`)}
                                    icon={<b>?</b>}
                                />
                            </Box>
                        </Box>
                        {
                            func && (
                                <Fragment>
                                    {func.id === GENERIC_MEDIA && <GenericMedia />}
                                    {func.id === RADIO && <Radio />}
                                    {func.id === WEATHER && <Weather />}
                                    {func.id === SERVICE_CALL && <ServiceCall />}
                                    {func.id === SLIDE_SHOW && <SlideShow />}
                                    {func.id === REMOTE_SITE_LAUNCHER && <RemoteSiteLauncher />}
                                    {func.id === INFO_PAGE_RSS && <RSS />}
                                    {func.id === LAUNCH_TV_APP && <LaunchTVApp />}
                                    {func.id === PLAY_MOVIE && <PlayMovie />}
                                    {func.id === START_INACTIVE_BROWSER && <StartInActiveBrowser />}
                                    {func.id === GENERIC_QR_CASTER && <GenericQRCaster />}
                                    {func.id === MEDIA_GRID && <MediaGrid />}
                                    {func.id === EXTERNAL_SERVICES && <Box></Box>}
                                    {/*{func.id === CHILD_LOCK && <ChildLock />}*/}
                                </Fragment>
                            )
                        }
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default Application;
